module.exports = {
  baseUrl: 'https://etk.nmgrmtzx.top/api/',
  projectName: '鄂托克旗融媒体中心智能管理系统'
}
